import React, { useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";

const ScrollToTop = ({ top }) => {
  const [is_visible, setIs_visible] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      toggleVisibility();
    });
  });

  let toggleVisibility = () => {
    if (window.pageYOffset > 1500) {
      setIs_visible(true);
    } else {
      setIs_visible(false);
    }
  };

  let scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="scroll-to-top">
      {is_visible && (
        <Tooltip title="Back to top" arrow placement="left">
          <div onClick={scrollToTop}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35px"
              height="55px"
              viewBox="0 0 16.139584 21.166666"
            >
              <defs>
                <linearGradient
                  x1="108.479"
                  x2="105.833"
                  y1="-41.667"
                  y2="106.5"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="matrix(.104 0 0 .104 5.098 266.05)"
                ></linearGradient>
                <linearGradient id="a_u">
                  <stop stopColor="#222" offset="0"></stop>
                  <stop stopOpacity="0" stopColor="#222" offset="1"></stop>
                </linearGradient>
              </defs>
              <g>
                <g>
                  <path
                    fill="#d0321e"
                    d="M8.17.24l-3.3 13.72 3.3 7.13 3.3-7.14z"
                  ></path>
                  <path fill="#fa503b" d="M8.17.24L.5 13.54 5.16 13z"></path>
                  <path fill="#fa503b" d="M8.17.24l7.7 13.3L11.2 13z"></path>
                </g>
              </g>
            </svg>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default ScrollToTop;
